import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  // Browser credentials are persisted in localStorage and mirrored here for UI state.
  token: null,
  isAuthenticated: false,
  isSessionRestored: false,
  impersonation: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, access_token: token = null } = action.payload;
      state.user = user;
      state.token = token;
      state.isAuthenticated = true;
      state.isSessionRestored = true;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.isSessionRestored = true;
      state.impersonation = null;
    },
    sessionRestoreComplete: (state) => {
      state.isSessionRestored = true;
    },
    /**
     * Admin starts impersonating a partner.
     * The browser swaps its local token and retains the Admin backup token.
     */
    startImpersonation: (state, action) => {
      const { partner_id, partner_name, expires_at, session_id, access_token: token = null } = action.payload;
      const impersonation = {
        partnerId: partner_id,
        partnerName: partner_name,
        expiresAt: expires_at,
        sessionId: session_id,
      };

      state.impersonation = impersonation;
      state.token = token;
      state.isAuthenticated = true;
    },
    /**
     * The browser restores the protected Admin backup token.
     */
    endImpersonation: (state, action) => {
      state.impersonation = null;
      state.token = action.payload?.access_token || null;
    },
  },
});

export const { setCredentials, logout, sessionRestoreComplete, startImpersonation, endImpersonation } = authSlice.actions;
export default authSlice.reducer;
